"use client";
import { usePathname } from "next/navigation";
import { cn } from "@pulsex/utils";
import Link from "next/link";
import { siteHref } from "@/utils/links";

type SubMenu = {
  url: string;
  title: string;
};

type Props = {
  data?: any;
  className?: string;
};

export default function SubMenuNav({ data, className }: Props) {
  const pathname = usePathname();
  const menuData = findMenuItemByPathname(data, decodeURI(pathname));

  if (
    !data ||
    !menuData?.subMenus ||
    menuData.subMenus?.length === 0 ||
    menuData?.title === "المزيد" ||
    !menuData?.url
  )
    return;

  return (
    <div
      className={cn(
        "flex items-center my-6 lg:mb-2 max-lg:my-3 max-md:mt-4 overflow-hidden",
        className
      )}
    >
      {menuData?.title &&
        (menuData?.url ? (
          <Link
            href={siteHref(menuData?.url, "#")}
            style={{ color: menuData?.icon }}
            className="ml-3 md:ml-6 lg:ml-10 text-3xl max-md:text-2xl text-nowrap"
          >
            {menuData?.title}
          </Link>
        ) : (
          <div
            style={{ color: menuData?.icon }}
            className="ml-3 md:ml-6 lg:ml-10 text-3xl cursor-pointer max-md:text-2xl text-nowrap"
          >
            {menuData?.title}
          </div>
        ))}

      <div className="flex items-center overflow-auto hide-scroll max-w-full">
        {menuData.subMenus.map((tab: SubMenu, index: number) => {
          const isActive = decodeURI(pathname).includes(tab?.url);

          return (
            <Link
              href={siteHref(tab?.url, "#")}
              key={index}
              className={cn(
                "text-3xl max-md:text-2xl cursor-pointer whitespace-nowrap ml-3 md:ml-6 lg:ml-10 text-nowrap",
                "text-black opacity-30 md:hover:opacity-65 transition-opacity",
                isActive && "opacity-65"
              )}
            >
              {tab?.title}
            </Link>
          );
        })}
      </div>
    </div>
  );
}

function findMenuItemByPathname(menus: any, pathname: string) {
  if (!menus || !Array.isArray(menus)) {
    console.warn("findMenuItemByPathname: Invalid menus data provided.");
    return undefined;
  }

  for (const item of menus) {
    if (item.url === pathname) {
      return item;
    }

    if (item.subMenus && Array.isArray(item.subMenus)) {
      for (const subItem of item.subMenus) {
        if (subItem.url === pathname) {
          return item;
        }
      }
    }
  }

  return undefined;
}
